var $ = require('jquery');
require('fg-frontend/plugins/jquery-model3D/jquery.model3D');

$(document).on('EDEESHOP_PRODUCT_MODEL3D_ACTIVATE', function(event, data) {

	// used for destroying any zoomed image active
	$(document).trigger('EDEESHOP_PHOTOGALLERY_PHOTO_CHANGE');

	$('.product-photogallery').addClass('with-model3d');

	window.active3DModel = $(event.target).model3D({
		data: data.images,
		width: 450,
		height: 450
	});


	$('<div class="model3d-remove js_model3d-remove"></div>').appendTo($(event.target)).on('click', function(event) {
		window.active3DModel.data('plugin_model3D').destroy();
		$('.product-photogallery').removeClass('with-model3d');
		$(event.currentTarget).off().remove();
	});
});

// deactivate on escape key
$(document).on('keyup', function(event) {
	var $modelObject = window.active3DModel;
	// 27 = escape
	if ($modelObject instanceof $ && event.which == 27) {
		$modelObject.data('plugin_model3D').destroy();
		$('.product-photogallery').removeClass('with-model3d');
		$('.js_model3d-remove', $modelObject).off().remove();
	}
});


// WEBPACK FOOTER //
// ./config/module-publish/resources/js/eshop-widgets/support-model3d.js